import { createMutation } from "/npm/@tanstack/solid-query@^5.67.1/+esm";

import client from "/npm/@brytdesigns/shopify-hybrid-cart@0.1.29/dist/jsdelivr/client.js";
import API from "/npm/@brytdesigns/shopify-hybrid-cart@0.1.29/dist/jsdelivr/api.js";
import { Cart } from "/npm/@brytdesigns/shopify-hybrid-cart@0.1.29/dist/jsdelivr/query/index.js";

export type Input = {
  key: string;
  id: string | number;
};

export const mutation = createMutation(
  () => ({
    mutationFn: async (item: Input) => {
      const cart = Cart.get();
      const currentItem = cart.items.find((i) => i.key === item.key);
      if (!currentItem) {
        throw new Error(
          `Item with provided key of ${item.key} does not exists!`
        );
      }

      const tempValues = {
        quantity: currentItem.quantity,
        properties: {
          ...currentItem.properties,
        },
        selling_plan:
          currentItem?.selling_plan_allocation?.selling_plan.id || undefined,
      } as const;

      await API.change({
        id: item.key,
        quantity: 0,
      });
      const response = await API.add({
        items: [
          {
            id: item.id,
            ...tempValues,
          },
        ],
      });
      if (response?.error || !response.data) {
        throw response?.error;
      }
      return response.data;
    },
    onSettled() {
      Cart.invalidate();
    },
  }),
  () => client
);
